module.exports = __webpack_public_path__ + "img/blue2.fdb5ea03.png";